import * as React from 'react';
import { Divider } from "@chakra-ui/react";

const Seperator = (props) => {
  return (
    <Divider borderTop="2px dashed #8c8b8b"/>
  );
};

export default Seperator;